import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import TrustedImg from "../../images/location_new/TekRevol.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Elevating San Francisco Startups with Cutting-Edge Software
              Solutions
            </h2>
            <p>
              San Francisco is the birthplace of countless startups and it
              deserves software solutions that match its dynamic spirit. At
              TekRevol, we're dedicated to propelling these startups to new
              heights with cutting-edge software solutions tailored to their
              unique needs.
            </p>
            <p>
              Our mission is clear: to provide startups in San Francisco with
              the technological edge they require to thrive in the competitive
              tech ecosystem. We understand the challenges and opportunities
              that startups face, and our agile, forward-thinking approach
              allows us to craft software that not only meets but exceeds
              expectations.
            </p>
            <p>
              Our innovative solutions are designed to streamline operations,
              enhance user experiences, and drive growth.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <LazyLoadImage
                src={TrustedImg}
                effect="blur"
                alt="TrustedImg"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
